import { render, staticRenderFns } from "./WorkshopKurikulum.vue?vue&type=template&id=933d3060"
import script from "./WorkshopKurikulum.vue?vue&type=script&lang=js"
export * from "./WorkshopKurikulum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports